import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import useAuth from "src/hooks/useAuth/useAuth";
import { useSocialProfile } from "src/hooks";
import { isAdmin, isSuperUser } from "src/utils/admin";

interface GuardRouteProps {
	specificGroup?: any | undefined;
	restrictedToEstateManager?: boolean;
}

const GuardRoute = ({
	specificGroup,
	restrictedToEstateManager
}: GuardRouteProps) => {
	const { userRoles } = useAuth();
	const { data: profile } = useSocialProfile();
	const location = useLocation();

	if (specificGroup) {
		return userRoles.includes(specificGroup) ? (
			<Outlet />
		) : (
			<Navigate to="/access-denied" replace state={{ from: location }} />
		);
	} else if (restrictedToEstateManager) {
		if (
			profile?.retail_user?.manager_of_area ||
			profile?.retail_user?.manager_of_region ||
			profile?.retail_user?.manager_of_store ||
			userRoles.includes("observation-reporting")
		) {
			return <Outlet />;
		} else {
			return (
				<Navigate to="/access-denied" replace state={{ from: location }} />
			);
		}
	} else {
		return isSuperUser(userRoles) || isAdmin(userRoles) ? (
			<Outlet />
		) : (
			<Navigate to="/access-denied" replace state={{ from: location }} />
		);
	}
};

export default GuardRoute;
